import { CheckCircle, mergeClassName, XCircle } from '@chain-zen/ui'

import { AuthorizationStatusEnum, type IDeviceInfo, type TLocationSettingsType } from '../../../../types/tracking'
import { DeviceInfoRow } from './shared'

interface DeviceStatusSectionProps {
  device: IDeviceInfo | null
  locationSettings: TLocationSettingsType | null
  hasSentMockLocations: boolean
  isShipmentOwner: boolean
}

const StatusIcon = ({ isPositive }: { isPositive: boolean | undefined }) => {
  const IconComponent = isPositive ? CheckCircle : XCircle
  return (
    <IconComponent
      className={mergeClassName(
        'h-4 w-4',
        isPositive ? 'text-green-400 dark:text-green-300' : 'text-red-500 dark:text-red-400'
      )}
    />
  )
}

export const DeviceStatusSection = ({
  device,
  locationSettings,
  hasSentMockLocations,
  isShipmentOwner
}: DeviceStatusSectionProps) => (
  <div className="flex flex-col gap-2 items-start w-full py-2">
    <span className="text-foreground font-semibold">Device Status</span>

    <DeviceInfoRow icon={<StatusIcon isPositive={!device?.isDeviceVirtual} />}>
      {device?.isDeviceVirtual ? 'Not a legitimate device' : 'Legitimate device'}
    </DeviceInfoRow>

    <DeviceInfoRow icon={<StatusIcon isPositive={locationSettings?.locationServicesEnabled ?? false} />}>
      {locationSettings?.locationServicesEnabled ? 'Location services enabled' : 'Location services disabled'}
    </DeviceInfoRow>

    <DeviceInfoRow icon={<StatusIcon isPositive={locationSettings?.gpsGeolocationProviderAvailable ?? false} />}>
      {locationSettings?.gpsGeolocationProviderAvailable ? 'GPS enabled' : 'GPS disabled'}
    </DeviceInfoRow>

    {!!hasSentMockLocations && !!isShipmentOwner && (
      <DeviceInfoRow icon={<StatusIcon isPositive={!hasSentMockLocations} />}>
        Fake locations detected. This means that the driver is using a fake GPS app.
      </DeviceInfoRow>
    )}

    {!!locationSettings?.authorizationStatus && (
      <DeviceInfoRow
        icon={
          <StatusIcon
            isPositive={locationSettings?.authorizationStatus === AuthorizationStatusEnum.AuthorizationStatusAlways}
          />
        }
      >
        Permissions: {locationSettings?.authorizationStatus}
      </DeviceInfoRow>
    )}
  </div>
)
